export const shouldRender = (data) => {
    return data.currentAccount.isUnlimited;
};
export const Component = function UnlimitedAccount() {
    return null;
};
//# sourceMappingURL=UnlimitedAccount.js.map
// @zapier/universal-layout@11.4.2 (c660b09a7)
